import { ApiServiceBase } from './ApiServiceBase'

export default class extends ApiServiceBase {
  async store(username: string) {
    return await this.call('/spa/influencer/ownership', {
      method: 'post',
      body: {
        username,
      },
    })
  }

  async update() {
    return await this.call('/spa/influencer/ownership', {
      method: 'put',
    })
  }

  async delete() {
    return await this.call('/spa/influencer/ownership', {
      method: 'delete',
    })
  }
}
